import { Divider, Fade, Stack, Typography } from "@mui/material";

function About() {
  return (
    <Fade in={true} timeout={500}>
      <Stack alignItems="center" spacing={4}>
        <Typography variant="h4">What is 3D Poses?</Typography>
        <Typography variant="body1">
          One of the biggest hurdles to overcome when learning how to draw is
          the lack of spatial awareness - rendering 3d space on a flat,
          two-dimensional surface. Thus, 3D Poses is a tool designed to help you
          develop a perception of the human figure in the three-dimensional
          space, and nourish a sense of spatial awareness that is fundamental if
          you are serious about learning how to draw.
        </Typography>
        <Divider />
        <Typography variant="h4">How do I use it (ideally)?</Typography>
        <Typography variant="body1">
          Of course, you can use this tool as you see fit! However, I recommend
          finding the horizon line first, then identifying the ground plane.
          Make sure your figure is always solidly anchored to the ground and
          follows perspective. If you have trouble identifying simpler volumes,
          use the wireframe version to understand how the various parts of the
          body are oriented, or the mannequin for even easier analysis. Once
          these key points are established, start drawing a simple gesture for
          the figure, then add the forms.
        </Typography>
        <Divider />
        <Typography variant="h4">Don't just copy!</Typography>
        <Typography variant="body1">
          Actually, don’t copy at all. Analyze the figure, see how much space it
          occupies, where it stands/sits/lies. Rather than proportions (which
          are still important), make your focus on constructing the figure in
          simple forms that occupy a clear volume.
        </Typography>
        <Divider />
        <Typography variant="h4">Keep drawing from life!</Typography>
        <Typography variant="body1">
          This tool can help you understand the three-dimensional space on a
          flat surface, but it is definitely not a substitute for life drawing;
          my advice is to keep drawing from real life as much as possible!
        </Typography>
        <Divider />
      </Stack>
    </Fade>
  );
}

export default About;
